import axios from "axios";
import { templateProviderDiagnostics } from "./utils/template-provider-diagnostics";
import { getRestApiUrl } from "./utils/backendOverride";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API}`,
});

API.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_PAYMENTS}`;
  // Resolved per request: the A/B company is routed to the sin-Prisma backend.
  config.baseURL = `${getRestApiUrl()}/v2`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    // `message` conserva la semántica legacy (userMessage o el data completo);
    // el resto son campos aditivos para que los consumidores puedan mapear
    // códigos de error sin depender de ese shape.
    const jcnError = {
      message: data?.userMessage || data,
      errorCode: data?.error,
      userMessage: data?.userMessage,
      internalCode: data?.internalCode,
      httpCode: error.response?.status,
      // Preserve legacy ownership when absent, but never promote malformed refs.
      ...(data?.supportRef === undefined ? { supportRef: undefined } : {}),
      ...templateProviderDiagnostics(data),
    };
    if (jcnError.message === "UNAUTHORIZED") {
      localStorage.clear();
      window.location.replace("/");
    }
    return Promise.reject(jcnError);
  }
);

export default API;
